import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getReplay } from '../GameLog/actions';
import { selectReplayEntries } from '../GameLog/selectors';
import { replayStart } from './replayStart';

/**
 * Where a replay of the game is: its moves (each with its board) and the one shown, starting at the first move you
 * haven't seen (`seenVersion`), else the latest move. `step(-1)` and `step(1)` go back and forward; `forward` is
 * whether the last step went forward (cards fly then).
 *
 * @returns {{ entries: ?object[], index: ?number, entry: ?object, step: function, forward: boolean }}
 */
export default function useReplay(gameId, seenVersion, on) {
  const dispatch = useDispatch();
  const entries = useSelector((state) => selectReplayEntries(state, { gameId }));
  const [index, setIndex] = useState(null);
  const [forward, setForward] = useState(false);

  useEffect(() => {
    if (on) {
      setIndex(null);
      dispatch(getReplay(gameId));
    }
  }, [on, gameId, dispatch]);

  useEffect(() => {
    if (on && entries && index === null) {
      setIndex(replayStart(entries, seenVersion));
      setForward(false);
    }
  }, [on, entries, index, seenVersion]);

  const last = entries ? entries.length - 1 : 0;
  const step = (by) => {
    setForward(by > 0);
    setIndex(i => Math.max(0, Math.min(last, i + by)));
  };

  const ready = on && entries && index !== null;
  return {
    entries: ready ? entries : null,
    index: ready ? index : null,
    entry: ready && entries.length ? entries[index] : null,
    step,
    forward,
  };
}
